import { Injectable } from '@angular/core';
import { Observable, Subject, filter, takeUntil } from 'rxjs';
import { Message } from 'services/socket/model/message';
import { MessageType } from 'services/socket/model/message-type';
import { SocketService } from 'services/socket/socket.service';
import { SocketMethod } from "src/app/services/socket/classes/socket-method";
import { Device, SubscriptionRequest } from './subscription-common';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private static subscriptions: Array<SubscriptionRequest> = [];
  private unsubscribe: Subject<void> = new Subject();
  private static subscriptionRequests: number = 0;

  constructor(
    private socketService: SocketService
  ) { }

  // Returns a structured subscription to SocksetService call
  // Restructures to format backend understands
  private createRequest(): any {
    let tmp = {
      sources: SubscriptionService.subscriptions
    }
    return {
      action: SocketMethod.SubscribeTelemetry,
      subscription: tmp
    }
  } // createRequest()

  public sendSubscriptionRequest(): void {
    SubscriptionService.subscriptionRequests++;
  } // sendSubscriptionRequest()

  public get getSubscriptionRequestCount(): number {
    return SubscriptionService.subscriptionRequests;
  } // getSubscriptionRequestCount()

  public sendSubscription(): void {
    if (this.socketService.Connected) {
      const request = this.createRequest()
      this.socketService.sendMessage(request)
      SubscriptionService.subscriptionRequests = 0;
    }
  } // setSubscription()

  public listenForDtcMessages(): Observable<Message> {
    return this.socketService.Messages.pipe(takeUntil(this.unsubscribe),
      filter((message) => message.eventType === MessageType.DTC));
  } // listenForTelementryMessages()

  public listenForTelementryMessages(): Observable<Message> {
    return this.socketService.Messages.pipe(takeUntil(this.unsubscribe),
      filter((message) => message.eventType === MessageType.Telemetry));
  } // listenForTelementryMessages()

  public appendDTCSubscription(sourceId: string): void {
    // See if source is already in subscription?
    const found = SubscriptionService.subscriptions.find(source => {
      return source.sourceId == sourceId ? source : undefined;
    });

    if (found) {
      found.DTC = true;
      return;
    }
    // Not found, add
    SubscriptionService.subscriptions.push({
      sourceId: sourceId,
      devices: [],
      DTC: true
    });
  } // appendDTCSubscription()

  public appendSubscription(requests: Array<SubscriptionRequest>): void {

    requests.forEach((request: SubscriptionRequest) => {
      const subSource = SubscriptionService.subscriptions.find((item: SubscriptionRequest) => item.sourceId == request.sourceId)
      // Source exists in Subscription, Check for Device
      if (subSource != undefined) {
        // See if Request Devices are in Subscription
        request.devices.forEach((reqDevice: Device) => {
          const subDevice = subSource.devices.find((item: Device) => item.deviceId == reqDevice.deviceId)
          if (subDevice != undefined) {
            // Merge the signals
            subDevice.signals = [...new Set([...subDevice.signals, ...reqDevice.signals])]
          } else {
            subSource.devices.push(reqDevice)
          }
        })
      } else { // Source not in subscription, so append everything
        SubscriptionService.subscriptions.push(request)
      }
    })

  } // appendSubscription()

  // Resets the subscription list
  public resetSubscription(): void {
    SubscriptionService.subscriptions = [];
    // TODO: Removed for now
    // this.sendSubscription();
  } // Empty()

} // class SubscriptionService
